import React from "react";

import { Typography, Stack } from "@mui/material";

interface WizardTitleProps {
  title: string;
  subtitle?: string;
}

const WizardTitle = ({ title, subtitle }: WizardTitleProps) => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography variant="h1">{title}</Typography>
      {subtitle && (
        <Typography
          variant="bodyPrimaryReg"
          sx={{ color: "shades.neutral.500" }}
        >
          {subtitle}
        </Typography>
      )}
    </Stack>
  );
};

export default WizardTitle;
